import { render, staticRenderFns } from "./AppPanicom.vue?vue&type=template&id=540e93c4&lang=pug&"
import script from "./AppPanicom.vue?vue&type=script&lang=ts&"
export * from "./AppPanicom.vue?vue&type=script&lang=ts&"
import style0 from "./AppPanicom.vue?vue&type=style&index=0&id=540e93c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports